import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  FormControl,
  Grid,
  Button,
  TextField,
  MenuItem,
  Snackbar,
} from "@material-ui/core";
import * as Yup from "yup";
import { Formik } from "formik";

import PageTitle from "src/components/PageTitle";
import MyInput from "src/components/Input";
import MySelect from "src/components/Select";
import MyButton from "src/components/Button";

import { userList, languageList } from "./data";
import DefaultImg from "src/assets/images/file-upload.png";

// Icon
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  userOneSelector,
  get as getUser,
  resetState,
} from "src/state/user-one/reducer";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  form: {
    textAlign: "left",
    padding: "1.25rem",
    margin: "0 auto",
    boxShadow: "0 -3px 31px 0 rgb(0 0 0 / 5%), 0 6px 20px 0 rgb(0 0 0 / 2%)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "42%",
    },
  },
  typo: {
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0",
    },
    [theme.breakpoints.up("sm")]: {
      margin: "15px 0",
    },
  },
  // Button Upload
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
  // Style Box
  styleBox: {
    borderRadius: "5px",
    border: "1px dashed grey",
    padding: "2rem",
  },
  inputField: {
    padding: 8,
  },
}));

// Fake Data
const typeData = [
  { value: 0, label: "Admin" },
  { value: 1, label: "Member" },
];

export default function UserEdit() {
  const classes = useStyles();
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data } = useSelector(userOneSelector);

  const [open, setOpen] = useState(false);
  const [messageCreateRole, setMessageCreateRole] = useState({
    message: "",
    status: "error",
  });

  useEffect(() => {
    fetchUserById(id);
    return () => {
      dispatch(resetState());
    };
  }, []);

  const fetchUserById = (id) => {
    dispatch(
      getUser({
        payload: {
          id,
        },
        callback: (res) => {
          if (!res?.payload) {
            setMessageCreateRole({
              message: "Can't found User",
              status: "error",
            });
            setOpen(true);
            setTimeout(() => {
              navigate("/vcms/user/list", { replace: true });
            }, 2000);
          }
          return;
        },
      })
    );
  };

  const handleEditUser = (values, callback) => {
    console.log(values);
    console.log(document.getElementById("contained-button-file").value);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <PageTitle>Edit User</PageTitle>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={messageCreateRole.status}>
          {messageCreateRole.message}
        </Alert>
      </Snackbar>
      <Box
        p={2}
        mt={2}
        style={{ background: "white", textAlign: "center" }}
        borderRadius={2}
      >
        <Formik
          enableReinitialize
          initialValues={{
            email: data ? data?.email : "",
            full_name: data ? data?.full_name : "",
            type: data ? data?.type : "0",
            role: data ? data?.role_user?.role?.display_name : "",
            country: data ? data?.country : "vi",
            address: data ? data?.address : "",
            phone: data ? data?.user_phone?.phone : "",
            password: "",
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email("Must be a valid email")
              .required("Email is required"),
            full_name: Yup.string().required("Full name is required"),
            type: Yup.string().required("Role is required"),
            address: Yup.string().required("Address is required"),
            phone: Yup.string()
              .matches(/^\d+$/, "Số điện thoại không hợp lệ")
              .required("Phone is required"),
            password: Yup.string().required("Password is required"),
          })}
          onSubmit={handleEditUser}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }) => (
            <Box classes={{ root: classes.form }}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={6}>
                    <div className={classes.root}>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          document
                            .getElementById("contained-button-file")
                            .click()
                        }
                      >
                        <img
                          style={{ width: "100%", objectFit: "cover" }}
                          src={
                            data
                              ? `https://dashboard.epispost.com/${data?.image}`
                              : DefaultImg
                          }
                          id="img_logo"
                        />
                      </div>
                      <input
                        style={{ display: "none" }}
                        accept="image/*"
                        className={classes.input}
                        id="contained-button-file"
                        type="file"
                        onChange={(e) => {
                          var output = document.getElementById("img_logo");
                          output.src = URL.createObjectURL(
                            event.target.files[0]
                          );
                          output.onload = function() {
                            URL.revokeObjectURL(output.src); // free memory
                          };
                        }}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          color="textSecondary"
                          classes={{ root: classes.typo }}
                        >
                          Email
                        </Typography>
                        <TextField
                          error={Boolean(touched.email && errors.email)}
                          fullWidth
                          helperText={touched.email && errors.email}
                          name="email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="email"
                          value={values.email}
                          variant="outlined"
                          inputProps={{
                            className: classes.inputField,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          color="textSecondary"
                          classes={{ root: classes.typo }}
                        >
                          Họ và tên
                        </Typography>
                        <TextField
                          error={Boolean(touched.full_name && errors.full_name)}
                          fullWidth
                          helperText={touched.full_name && errors.full_name}
                          name="full_name"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          value={values.full_name}
                          variant="outlined"
                          inputProps={{
                            className: classes.inputField,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          color="textSecondary"
                          classes={{ root: classes.typo }}
                        >
                          Loại tài khoản
                        </Typography>
                        <TextField
                          error={Boolean(touched.type && errors.type)}
                          fullWidth
                          helperText={touched.type && errors.type}
                          name="type"
                          select
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.type}
                          variant="outlined"
                          inputProps={{
                            className: classes.inputField,
                          }}
                        >
                          <MenuItem value="0">Member</MenuItem>
                          <MenuItem value="1">Admin</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          color="textSecondary"
                          classes={{ root: classes.typo }}
                        >
                          Role
                        </Typography>
                        <TextField
                          error={Boolean(touched.role && errors.role)}
                          fullWidth
                          helperText={touched.role && errors.role}
                          name="role"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          value={values.role}
                          variant="outlined"
                          inputProps={{
                            className: classes.inputField,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* ------------------------------ */}
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <Typography
                          variant="h6"
                          color="textSecondary"
                          classes={{ root: classes.typo }}
                        >
                          Mã vùng
                        </Typography>
                        <TextField
                          error={Boolean(touched.country && errors.country)}
                          fullWidth
                          helperText={touched.country && errors.country}
                          name="country"
                          select
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.country}
                          variant="outlined"
                          inputProps={{
                            className: classes.inputField,
                          }}
                        >
                          <MenuItem value="vi">+84</MenuItem>
                          <MenuItem value="au">+61</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography
                          variant="h6"
                          color="textSecondary"
                          classes={{ root: classes.typo }}
                        >
                          Số điện thoại
                        </Typography>
                        <TextField
                          error={Boolean(touched.phone && errors.phone)}
                          fullWidth
                          helperText={touched.phone && errors.phone}
                          name="phone"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          value={values.phone}
                          variant="outlined"
                          inputProps={{
                            className: classes.inputField,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      name="address"
                      color="textSecondary"
                      classes={{ root: classes.typo }}
                    >
                      Địa chỉ
                    </Typography>
                    <TextField
                      error={Boolean(touched.address && errors.address)}
                      fullWidth
                      helperText={touched.address && errors.address}
                      name="address"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="text"
                      value={values.address}
                      variant="outlined"
                      inputProps={{
                        className: classes.inputField,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      color="textSecondary"
                      classes={{ root: classes.typo }}
                    >
                      {data ? "New password" : "Password"}
                    </Typography>
                    <TextField
                      error={Boolean(touched.password && errors.password)}
                      fullWidth
                      helperText={touched.password && errors.password}
                      name="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="password"
                      value={values.password}
                      variant="outlined"
                      inputProps={{
                        className: classes.inputField,
                      }}
                    />
                  </Grid>
                </Grid>

                <Box mt={2} textAlign="center">
                  <MyButton
                    type="submit"
                    text="Lưu"
                    color="success"
                    style={{ marginRight: 15 }}
                  />
                  <NavLink to="/vcms/user/list">
                    <MyButton text="Hủy" color="secondary" />
                  </NavLink>
                </Box>
              </form>
            </Box>
          )}
        </Formik>
      </Box>
    </>
  );
}
